import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Button from '../components/shared/Button.svelte';
import DatePicker from '../components/shared/DatePicker.svelte';
import { addChild } from '../lib/stores/children.svelte.ts';
import { setActiveChildId, setOnboardingCompleted } from '../lib/stores/appState.svelte.ts';
import { navigate } from '../lib/router.svelte.ts';

var root_1 = $.from_html(`<header class="hero svelte-2od9p1enn0jx1"><h1 class="svelte-2od9p1enn0jx1">Let's set up<br/>your children</h1> <p class="svelte-2od9p1enn0jx1">Tell us how many you're tracking. You can always add more later.</p></header> <section class="stepper-card svelte-2od9p1enn0jx1" aria-labelledby="count-label"><span class="stepper-label svelte-2od9p1enn0jx1" id="count-label">Number of children</span> <div class="stepper svelte-2od9p1enn0jx1"><button type="button" class="step-btn svelte-2od9p1enn0jx1" aria-label="Decrease">−</button> <span class="count svelte-2od9p1enn0jx1" aria-live="polite"> </span> <button type="button" class="step-btn svelte-2od9p1enn0jx1" aria-label="Increase">+</button></div></section> <div class="actions svelte-2od9p1enn0jx1"><!></div>`, 1);
var root_3 = $.from_html(`<header class="hero svelte-2od9p1enn0jx1"><p class="progress svelte-2od9p1enn0jx1"> </p> <h1 class="svelte-2od9p1enn0jx1">Tell us about them</h1> <p class="svelte-2od9p1enn0jx1">A name and birthday so we can personalise their dashboard.</p></header> <div class="form svelte-2od9p1enn0jx1"><div class="field svelte-2od9p1enn0jx1"><label for="name" class="svelte-2od9p1enn0jx1">Name</label> <input id="name" type="text" autocomplete="off" autocapitalize="words" inputmode="text" placeholder="e.g. Luna" class="svelte-2od9p1enn0jx1"/></div> <div class="field svelte-2od9p1enn0jx1"><label for="dob" class="svelte-2od9p1enn0jx1">Date of birth</label> <!></div></div> <div class="actions actions-row svelte-2od9p1enn0jx1"><!> <!></div>`, 1);
var root_9 = $.from_html(`<div class="finishing svelte-2od9p1enn0jx1"><div class="spinner svelte-2od9p1enn0jx1" aria-hidden="true"></div> <p>Setting things up…</p></div>`);
var root = $.from_html(`<div class="onboarding-frame svelte-2od9p1enn0jx1"><div class="onboarding svelte-2od9p1enn0jx1"><div class="brand-row svelte-2od9p1enn0jx1"><div class="logo-circle svelte-2od9p1enn0jx1" aria-hidden="true"><svg viewBox="0 0 24 24" width="18" height="18"><path d="M12 3C10 7 6 9 6 13a6 6 0 0012 0c0-4-4-6-6-10z" fill="white" opacity="0.9"></path><path d="M12 3c2 4 6 6 6 10" stroke="white" stroke-width="1.2" stroke-linecap="round" opacity="0.5"></path></svg></div> <span class="brand-name svelte-2od9p1enn0jx1">mamaobaby</span></div> <!></div></div>`);

function Onboarding($$anchor, $$props) {
	$.push($$props, true);

	let step = $.state('count');
	let count = $.state(1);
	let drafts = $.state($.proxy([{ name: '', dob: '' }]));
	let currentIndex = $.state(0);

	function setCount(n) {
		$.set(count, n, true);
		$.set(drafts, Array.from({ length: n }, (_, i) => $.get(drafts)[i] ?? { name: '', dob: '' }), true);
	}

	function goToDetails() {
		$.set(step, 'details');
		$.set(currentIndex, 0);
	}

	function nextChild() {
		if ($.get(currentIndex) < $.get(count) - 1) {
			$.set(currentIndex, $.get(currentIndex) + 1);
		}
	}

	function prevChild() {
		if ($.get(currentIndex) > 0) {
			$.set(currentIndex, $.get(currentIndex) - 1);
		} else {
			$.set(step, 'count');
		}
	}

	async function finish() {
		$.set(step, 'finishing');

		const created = [];

		for (const draft of $.get(drafts)) {
			const dob = draft.dob ? new Date(draft.dob).getTime() : Date.now();
			const child = await addChild({ name: draft.name.trim(), dateOfBirth: dob });

			created.push(child);
		}

		if (created.length > 0) {
			await setActiveChildId(created[0].id);
		}

		await setOnboardingCompleted(true);
		navigate('/');
	}

	const currentDraft = $.derived(() => $.get(drafts)[$.get(currentIndex)]);
	const canContinueDetails = $.derived(() => $.get(currentDraft) && $.get(currentDraft).name.trim().length > 0);
	const isLast = $.derived(() => $.get(currentIndex) === $.get(count) - 1);
	var div = root();
	var div_1 = $.child(div);
	var node = $.sibling($.child(div_1), 2);

	{
		var consequent = ($$anchor) => {
			var fragment = root_1();
			var section = $.sibling($.first_child(fragment), 2);
			var div_2 = $.sibling($.child(section), 2);
			var button = $.child(div_2);
			var span = $.sibling(button, 2);
			var text = $.child(span, true);

			$.reset(span);

			var button_1 = $.sibling(span, 2);

			$.reset(div_2);
			$.reset(section);

			var div_3 = $.sibling(section, 2);
			var node_1 = $.child(div_3);

			Button(node_1, {
				variant: 'primary',
				fullWidth: true,
				onclick: goToDetails,
				children: ($$anchor, $$slotProps) => {
					$.next();

					var text_1 = $.text('Continue');

					$.append($$anchor, text_1);
				},
				$$slots: { default: true }
			});

			$.reset(div_3);

			$.template_effect(() => {
				button.disabled = $.get(count) <= 1;
				$.set_text(text, $.get(count));
				button_1.disabled = $.get(count) >= 6;
			});

			$.delegated('click', button, () => setCount(Math.max(1, $.get(count) - 1)));
			$.delegated('click', button_1, () => setCount(Math.min(6, $.get(count) + 1)));
			$.append($$anchor, fragment);
		};

		var consequent_2 = ($$anchor) => {
			var fragment_1 = root_3();
			var header = $.first_child(fragment_1);
			var p = $.child(header);
			var text_2 = $.child(p);

			$.reset(p);
			$.next(4);
			$.reset(header);

			var div_4 = $.sibling(header, 2);
			var div_5 = $.child(div_4);
			var input = $.sibling($.child(div_5), 2);

			$.remove_input_defaults(input);
			$.reset(div_5);

			var div_6 = $.sibling(div_5, 2);
			var node_2 = $.sibling($.child(div_6), 2);

			DatePicker(node_2, {
				id: 'dob',
				get value() {
					return $.get(drafts)[$.get(currentIndex)].dob;
				},
				onchange: (v) => $.get(drafts)[$.get(currentIndex)].dob = v,
				placeholder: 'Optional'
			});

			$.reset(div_6);
			$.reset(div_4);

			var div_7 = $.sibling(div_4, 2);
			var node_3 = $.child(div_7);

			Button(node_3, {
				variant: 'secondary',
				fullWidth: true,
				onclick: prevChild,
				children: ($$anchor, $$slotProps) => {
					$.next();

					var text_3 = $.text('Back');

					$.append($$anchor, text_3);
				},
				$$slots: { default: true }
			});

			var node_4 = $.sibling(node_3, 2);

			{
				var consequent_1 = ($$anchor) => {
					var fragment_2 = $.comment();
					var node_5 = $.first_child(fragment_2);

					{
						let $0 = $.derived(() => !$.get(canContinueDetails));

						Button(node_5, {
							variant: 'primary',
							fullWidth: true,
							onclick: finish,
							get disabled() {
								return $.get($0);
							},

							children: ($$anchor, $$slotProps) => {
								$.next();

								var text_4 = $.text('Finish');

								$.append($$anchor, text_4);
							},
							$$slots: { default: true }
						});
					}

					$.append($$anchor, fragment_2);
				};

				var alternate = ($$anchor) => {
					var fragment_3 = $.comment();
					var node_6 = $.first_child(fragment_3);

					{
						let $0 = $.derived(() => !$.get(canContinueDetails));

						Button(node_6, {
							variant: 'primary',
							fullWidth: true,
							onclick: nextChild,
							get disabled() {
								return $.get($0);
							},

							children: ($$anchor, $$slotProps) => {
								$.next();

								var text_5 = $.text('Next');

								$.append($$anchor, text_5);
							},
							$$slots: { default: true }
						});
					}

					$.append($$anchor, fragment_3);
				};

				$.if(node_4, ($$render) => {
					if ($.get(isLast)) $$render(consequent_1); else $$render(alternate, -1);
				});
			}

			$.reset(div_7);
			$.template_effect(() => $.set_text(text_2, `Child ${$.get(currentIndex) + 1} of ${$.get(count) ?? ''}`));
			$.bind_value(input, () => $.get(drafts)[$.get(currentIndex)].name, ($$value) => $.get(drafts)[$.get(currentIndex)].name = $$value);
			$.append($$anchor, fragment_1);
		};

		var alternate_1 = ($$anchor) => {
			var div_8 = root_9();

			$.append($$anchor, div_8);
		};

		$.if(node, ($$render) => {
			if ($.get(step) === 'count') $$render(consequent); else if ($.get(step) === 'details') $$render(consequent_2, 1); else $$render(alternate_1, -1);
		});
	}

	$.reset(div_1);
	$.reset(div);
	$.append($$anchor, div);
	$.pop();
}

if (import.meta.hot) {
	Onboarding = $.hmr(Onboarding);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-2od9p1enn0jx1');
		Onboarding[$.HMR].update(module.default);
	});
}

export default Onboarding;

$.delegate(['click']);
import "bun-svelte:Onboarding.svelte-1a8j32pp75dhg-style.css";